const objectKeys = (obj) => Object.keys(obj);
export {
  objectKeys
};
//# sourceMappingURL=object-keys.js.map
